import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PhxDragItemComponent } from '../drag-items/base/phx-drag-item.component';
import { Drag } from '../../icon/icon-map';

@Component({
  selector: 'phx-drag-handle',
  template: `
    <button *ngIf="phxInteractive" phx-icon-button [phxIcon]="phxIcon || DragIcon"></button>
    <i *ngIf="!phxInteractive" phx-icon [phxIcon]="phxIcon || DragIcon"></i>
  `,
  styleUrls: ['./phx-drag-handle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'phx-drag-handle' },
})
export class PhxDragHandleComponent implements OnChanges, AfterViewInit {
  @Input() phxInteractive: boolean = true;
  @Input() phxIcon: string;

  public readonly DragIcon: string = Drag;

  constructor(private _elementRef: ElementRef, private _phxDragItemComponent: PhxDragItemComponent) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { phxInteractive } = changes;

    if (phxInteractive && !phxInteractive.firstChange) {
      if (phxInteractive.currentValue) {
        this._phxDragItemComponent.registerDragHandle(this._elementRef);
      } else {
        this._phxDragItemComponent.unregisterDragHandle();
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.phxInteractive) {
      setTimeout(() => { // Temporary fix for ExpressionChangedAfterItHasBeenCheckedError
        this._phxDragItemComponent.registerDragHandle(this._elementRef);
      });
    }
  }
}
